import React, { useEffect, useState } from 'react'
import AuthCardComponent from '../../../components/login-card/auth-card.component'
import { Button, Col, message, Row, Typography } from 'antd';
import LilyButton from '../../../components/button/lily-button';
import { useNavigate } from 'react-router-dom';
import FastLinkBank from '../../../containers/fast-link-bank/fast-link-bank';
import portalAPI from "../../../api/api";
import { SAVE_BANK_ACCOUNTS_URL, YODLEE_GET_ACCOUNTS_DETAIL } from '../../../api/URLs';
import CardIcon from '../../../assets/card.svg';
import TrashIcon from '../../../assets/trash-icon.svg';
import { useDispatch } from 'react-redux';
import { updateUser } from '../../../stores/authenticated-user.store';
import BackButton from '../../../components/button/back-button';

const LinkAccountPage = () => {
    const { Text, Title } = Typography;
    const [isLoading, setIsLoading] = useState(false);
    const [accessToken, setAccessToken] = useState('');
    const [sites, setSites] = useState([]);
    const [accounts, setAccounts] = useState([]);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleSubmit = async () => {
        setIsLoading(true);

        try {
            const res = await portalAPI.put(SAVE_BANK_ACCOUNTS_URL, {
                accounts
            });

            if (res?.data?.status === 200) {
                message.success("Saved Bank Accounts Successfully");
                navigate("/setting/reimbursement-methods");
                dispatch(updateUser({
                    key: 'reimbursementMethods',
                    value: res.data.data.reimbursementMethods,
                }));
            } else {
                message.error(res?.data?.message || "Save Bank Accounts failed. Please try again.");
            }
        } catch (error) {
            message.error("Failed to submit claim. Please try again.");
        } finally {
            setIsLoading(false);
        }
    }

    const getAccountsDetail = async (accountIds) => {
        try {
            const rsp = await portalAPI.post(YODLEE_GET_ACCOUNTS_DETAIL, {
                accountIds: accountIds,
                accessToken: accessToken
            });
            if (rsp?.data?.data) {
                setAccounts(rsp?.data?.data);
            }
        } catch (err) {
            console.error("Error get accounts");
        }
    }

    useEffect(() => {
        if (sites.length > 0) {
            let accountIds = sites.map((item) => item.accountId);
            getAccountsDetail(accountIds);
        }
    }, [sites]);

    return (
        <div className='user-setting-layout'>
            <div className='w-100'>
                <BackButton path='/setting/reimbursement-methods' />
            </div>

            <div className='w-100 d-flex justify-content-center mt-4'>
                <AuthCardComponent
                    title='Direct Deposit Account'
                    description='Save your bank details to get reimbursed faster. Securely receive payments straight to your bank account.'
                    buttonEle={
                        <div className='w-100 d-flex justify-content-end mt-3'>
                            <LilyButton disabled={accounts.length < 1} loading={isLoading} onClick={handleSubmit} text="Save Information" />
                        </div>
                    }
                >
                    <div className='d-flex flex-column gap-3'>
                        <FastLinkBank setSites={setSites} setAccessToken={setAccessToken} />
                        {
                            accounts.length > 0 && (
                                <div>
                                    <Text>Bank Account Link</Text>
                                    <Row gutter={[16, 16]}>
                                        {
                                            accounts.map((item) => {
                                                let routingNumber = item?.bankTransferCode?.find((item) => item.type === 'ROUTING_NUMBER');
                                                return (
                                                    <Col xs={18}>
                                                        <div className='method-card'>
                                                            <div className='d-flex flex-row align-items-start gap-3'>
                                                                <img src={CardIcon} alt='Card Icon' style={{ width: '50px', height: 'fit-content', objectFit: 'cover' }} />
                                                                <div className='d-flex flex-column'>
                                                                    <Title level={5} style={{ fontWeight: '500' }}>Direct Deposit (ACH)</Title>
                                                                    <Text strong>{item.providerName}</Text>
                                                                    <Text>Account Name: {item.accountName}</Text>
                                                                    <Text>Account Type: {item.accountType}</Text>
                                                                    <Text>Account Number: {item.accountNumber}</Text>
                                                                    <Text>Routing Number: {routingNumber?.id || 'N/A'}</Text>
                                                                </div>
                                                            </div>
                                                            <div className='d-flex flex-row justify-content-end w-100'>
                                                                <Button onClick={() => {
                                                                    setAccounts((prevItems) => prevItems.filter(it => it.id !== item.id));
                                                                }} icon={<img className='mb-1' alt='trash-icon' src={TrashIcon} />} className='unlink-btn'>Unlink Account</Button>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                )
                                            })
                                        }
                                    </Row>
                                </div>
                            )
                        }
                    </div>
                </AuthCardComponent>
            </div>
        </div>
    )
}

export default LinkAccountPage